<template>
	<v-select
		v-model="model"
		v-bind="$attrs"
		:items="roles"
		item-value="id"
		label="בחר הרשאה"
		:disabled="lock"
	>
		<template #item="{ item ,on,attrs}">
			<v-list-item
				v-bind="attrs"
				v-on="on"
			>
				{{ item.text }}
			</v-list-item>
		</template>
	</v-select>
</template>

<script>

	import RoleManager from "dev/helpers/RoleManager";

	export default {
		name: "role-select",
		props: {
			value: { default: null },
			lowestRole: { type: Number },
			lock: { type: Boolean, default: false },
			selectedGroup: { default: null },
		},
		data () {
			return {
				options: null,
			};
		},
		computed: {
			model: {
				get () {
					return this.value;
				},
				set (val) {
					this.$emit("input", val);
				},
			},
			userRole () {
				return this.$store.state.AuthModule.user.role;
			},
			roles () {
				const lowestRole = this.lowestRole || this.userRole;
				return RoleManager.roles.filter(role => role.id >= lowestRole);
			},
		},
		methods: {},
	};
</script>
